import { render, staticRenderFns } from "./term.vue?vue&type=template&id=5f2f0f2f&"
import script from "./term.vue?vue&type=script&lang=ts&"
export * from "./term.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports